import { render, staticRenderFns } from "./InspectionIssueBadgeBar.vue?vue&type=template&id=1c876d59&scoped=true"
import script from "./InspectionIssueBadgeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionIssueBadgeBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionIssueBadgeBar.vue?vue&type=style&index=0&id=1c876d59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c876d59",
  null
  
)

export default component.exports